export const SUPPORTED_BOOK_LANGUAGES = [
  'English',
  'Russian',
  'Japanese',
  'Hebrew',
  'French',
  'Spanish',
  'Italian',
  'German',
  'Portuguese',
  'Dutch',
  'Swedish',
  'Norwegian',
  'Danish',
  'Finnish',
  'Polish',
  'Czech',
  'Slovak',
  'Romanian',
  'Turkish',
  'Vietnamese',
  'Catalan',
  'Ukrainian',
  'Bulgarian',
  'Greek',
  'Arabic',
  'Korean',
  'Chinese (Simplified)',
] as const;

export type SupportedBookLanguage = (typeof SUPPORTED_BOOK_LANGUAGES)[number];

/**
 * Languages that use right-to-left text direction.
 * These need RTL text rendering (e.g., CSS `direction: rtl`, PDF text alignment).
 */
export const RTL_TEXT_LANGUAGES = ['Hebrew', 'Arabic'] as const;

/**
 * Languages that use right-to-left page order (book reads from right to left).
 * Includes RTL text languages plus Japanese (which traditionally reads right-to-left).
 */
export const RTL_PAGE_ORDER_LANGUAGES = [
  'Hebrew',
  'Arabic',
  'Japanese',
] as const;

/**
 * Returns true if the given language uses right-to-left text direction.
 */
export function isRtlTextLanguage(language: SupportedBookLanguage): boolean {
  return (RTL_TEXT_LANGUAGES as ReadonlyArray<string>).includes(language);
}

/**
 * Returns true if the given language uses right-to-left page order.
 */
export function isRtlPageOrder(language: SupportedBookLanguage): boolean {
  return (RTL_PAGE_ORDER_LANGUAGES as ReadonlyArray<string>).includes(language);
}
